import { render, staticRenderFns } from "./Cpdetails.vue?vue&type=template&id=5860053b&scoped=true&"
import script from "./Cpdetails.vue?vue&type=script&lang=js&"
export * from "./Cpdetails.vue?vue&type=script&lang=js&"
import style0 from "./Cpdetails.vue?vue&type=style&index=0&id=5860053b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5860053b",
  null
  
)

export default component.exports